import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StudentWrapperComponent } from './student-wrapper.component';

@NgModule({
    imports: [
        CommonModule,
        // IMPORTANT: declare empty routes here and import the routes from the main routing module!
        //            the wrapper module must be imported from the main module.
        RouterModule.forChild([]),
        StudentWrapperComponent,
    ],
    exports: [StudentWrapperComponent],
    providers: [],
})
export class StudentWrapperModule {}
